const initialState = {
    statusShow: false,
};
const modalPwaIsIos = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_STATUS_DATA_MODAL_PWA_IS_IOS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalPwaIsIos;